<template>
    <b-form @submit="onSubmit" novalidate>
        <b-container class="container-panel">
            <b-row class="mb-2">
                <b-col>
                    <h2>Post Adjustment</h2>
                </b-col>
            </b-row>

            <!-- Adjustment Type-->
            <b-row class="mb-3">
                <b-col>
                    <label for="ddlAdjustmentType">Adjustment Types</label>
                    <b-form-input 
                                  :state="isAdjustmentTypeStateValid" 
                                  :disabled="isFormDisabled" 
                                  required 
                                  list ="ddlAdjustmentType" 
                                  v-on:change="onSelectChargeCodeChange" />
                    <b-form-datalist 
                                   id="ddlAdjustmentType"
                                   :options="adjustmentOptions">
                    </b-form-datalist>
                     
                    <!--<b-form-select v-on:change="onSelectChargeCodeChange"
                                   v-model="selectedChargeCode"
                                   required
                                   :disabled="isFormDisabled"
                                   :state="isAdjustmentTypeStateValid">
                        <b-form-select-option v-for="item in chargeCodeList"
                                              v-bind:value="item.id">
                        </b-form-select-option>-->
                    <b-form-invalid-feedback :state="isAdjustmentTypeStateValid">Please select an Adjustment Type</b-form-invalid-feedback>
                </b-col>
            </b-row>

            <!-- Bill Description-->
            <b-row class="mb-3">
                <b-col>
                    <label for="billDescription">Bill Description</label>
                    <b-form-input required
                                  v-model="billDescription"
                                  id="bill-description"
                                  aria-describedby="bill-description-help-block"
                                  :disabled="isFormDisabled"
                                  :state="isBillDescriptionStateValid"></b-form-input>
                    <b-form-text id="bill-description-help-block">
                        Bill Description will be auto-filled when an adjustment type is selected.  This can optionally be overwritten.
                    </b-form-text>
                    <b-form-invalid-feedback :state="isBillDescriptionStateValid">Bill Description should not be empty</b-form-invalid-feedback>
                </b-col>
            </b-row>

            <!-- ESIID-->
            <b-row class="mb-3">
                <b-col>
                    <label for="ddlEsiid">ESIID</label>
                    <b-form-select v-model="selectedEsiid"
                                   :disabled="isFormDisabled || isESIIDDisabled">
                        <b-form-select-option v-for="item in esiidList"
                                              v-bind:value="item.id">
                            {{item.desc}}
                        </b-form-select-option>
                    </b-form-select>
                    <!--<b-form-invalid-feedback>Please select an ESIID</b-form-invalid-feedback>-->
                </b-col>
            </b-row>

            <!-- Amount -->
            <b-row class="mb-4">
                <b-col>
                    <label for="amount">Amount</label>
                    <b-input required
                             v-model="amount"
                             id="amount"
                             placeholder="0.00"
                             type="number"
                             step="0.01"
                             min="0.00"
                             :disabled="isFormDisabled || isAmountDisabled"
                             :state="isAmountNumericValid && isAmountStateValid"></b-input>
                    <b-form-invalid-feedback :state="isAmountNumericValid"
                                             v-if="!isAmountNumericValid">Amount should not be empty</b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="isAmountStateValid"
                                             v-if="!isAmountStateValid">Amount has to be greater than 0</b-form-invalid-feedback>
                </b-col>
            </b-row>

            <!-- Notes -->
            <b-row class="mb-3">
                <b-col>
                    <label for="notes">Notes</label>
                    <b-form-textarea id="textarea"
                                     v-model="notes"
                                     required
                                     placeholder="Enter notes..."
                                     rows="2"
                                     max-rows="8"
                                     :disabled="isFormDisabled"
                                     :state="isNoteStateValid && isNoteMinMaxStateValid"></b-form-textarea>
                    <b-form-invalid-feedback :state="isNoteStateValid"
                                             v-if="!isNoteStateValid">Notes should not be empty.</b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="isNoteMinMaxStateValid"
                                             v-if="!isNoteMinMaxStateValid">Notes should be between 10 and 500 characters.</b-form-invalid-feedback>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col> &nbsp; </b-col>
            </b-row>

            <!-- Submit & Cancel buttons -->
            <b-row class="mb-3">
                <b-col>
                    <b-button type="submit"
                              variant="success"
                              :disabled="isFormDisabled">Submit</b-button> &nbsp;
                    <b-button type="button"
                              v-on:click="onCancel()"
                              :disabled="isFormDisabled">Cancel</b-button> &nbsp;
                </b-col>
            </b-row>

            <!-- System message(s) -->
            <b-row class="mb-3">
                <b-col>
                    <span :class="systemMessageStyleClass" style="font-size:24px">
                        {{systemMessage}}
                    </span>
                </b-col>
            </b-row>

        </b-container>

        <!-- Confirm post adjustment modal -->
        <b-modal id="confirm-modal" 
                 title="Submit"
                 @ok="submitPostAdjustment">
            <p class="my-4">Confirm post adjustment?</p>
        </b-modal>
    </b-form>
</template>

<script>
import AmbitLogo from '../components/AmbitLogo.vue';
import Repo from '../repo';
import i18n from '../localization';


export default {
    name: "PostAdjustment",

    //components: { AmbitLogo },

    data: () => {
        return {
            chargeCodeList: [
                {
                    id: null,
                    desc: "Select adjustment type",
                    origDesc: null,
                    amound: null
                }],
            esiidList: [],
            selectedChargeCode: null,
            selectedEsiid: null,
            billDescription: null,
            esiid: null,
            amount: null,
            notes: null,
            isAmountDisabled: false,
            agentUserId: null,
            systemMessage: null,
            systemMessageStyleClass: 'alert-info',
            isFormDisabled: false,
            isFormLoadState: true,
            isESIIDDisabled: false,
        };
    },

        computed: {
            adjustmentOptions() {
                return this.chargeCodeList.map(cc => cc.desc)
            },
        isAdjustmentTypeStateValid() {
            if (this.isFormLoadState) return null;

            if (this.selectedChargeCode != null)
                return true;
            else
                return false;

        },
        isBillDescriptionStateValid() {
            if (this.isFormLoadState) return null;

            if (this.billDescription == null) return false;

            if (this.billDescription.length > 0) return true;
        },
        isAmountNumericValid() {
            if (this.isFormLoadState) return null;

            if (this.isNumeric(this.amount))
                return true;
            else
                return false;
        },
        isAmountStateValid() {
            if (this.isFormLoadState) return null;

            if (this.amount != null &&
                this.isNumeric(this.amount) &&
                this.amount > 0)
                return true;
            else
                return false;
        },
        isNoteStateValid() {
            if (this.isFormLoadState) return null;

            if ((this.notes != null) && (this.notes.length > 0))
                return true;
            else
                return false;
        },
        isNoteMinMaxStateValid() {
            if (this.isFormLoadState) return null;

            if (this.notes != null && (this.notes.length >= 10 && this.notes.length <= 500))
                return true;
            else
                return false;
        },
        isAllFormDataValid() {
            if (this.isAdjustmentTypeStateValid &&
                this.isBillDescriptionStateValid &&
                this.isAmountNumericValid &&
                this.isAmountStateValid &&
                this.isNoteStateValid &&
                this.isNoteMinMaxStateValid)
                return true;
            else
                return false;
        },

    },

    mounted() {

        // Authorization (auth token validation) is handled on the api call when retrieving data
        //this.getPostAdjustmentViewModel();
        console.log('Token: ' + this.$route.query.token);
        Repo.AuthenticationService.ValidateToken({ Token: this.$route.query.token }).then(response => {
            if (response && response.success) {
                this.getPostAdjustmentViewModel();
            }
            else {
                
                let event = { Caller: "PostAdjustment.vue", Data: JSON.stringify(response) };
                console.log(JSON.stringify(response));
                console.log(event);
                Repo.EventLog.LogEvent(event);

                this.isFormDisabled = true;
                this.$store.dispatch('shell/addErrorMessages', i18n.t('NOT_AUTHENTICATED'));
            }
        });
    },

        methods: {
            
        onSubmit: async function (event) {

            event.preventDefault();

            // Clear out any prior system messages from server
            this.systemMessage = null;
            this.systemMessageStyleClass = null;

            // helps set the validation state of the bootstrap form inputs 
            this.isFormLoadState = false;

            // Show confirm modal
            if (this.isAllFormDataValid) {
                this.$bvModal.show('confirm-modal'); 
            }
        },
        onCancel: function () {

            this.selectedChargeCode = null;
            this.selectedEsiid = null;
            this.billDescription = null;
            this.amount = null;
            this.notes = null;
            this.systemMessage = null;
            this.systemMessageStyleClass = null;
            this.isFormLoadState = true;

            return;
        },
        onSelectChargeCodeChange: function (itemDesc) {

            const excludeEsiForChgCodes = ['AMA_TX_DAMAGECLAIM'];
            let selectedChargeCode = this.chargeCodeList.find(item => item.desc == itemDesc)
            if (selectedChargeCode == undefined) {
                this.billDescription = null
                this.selectedChargeCode = null
                return 
            }
            this.selectedChargeCode = selectedChargeCode.id
            var chargeCodeItem = this.chargeCodeList.find(item => item.id == this.selectedChargeCode);
            if (chargeCodeItem != null) {


                // Set bill desciption from charge code
                this.billDescription = chargeCodeItem.origDesc;

                // Set amount from charge code
                if (chargeCodeItem.amount != 0) {
                    this.amount = this.formatAmount(chargeCodeItem.amount);
                    //this.isAmountDisabled = false;
                }
                else {
                    this.amount = this.formatAmount(0);
                    //this.isAmountDisabled = true;
                }

                if (excludeEsiForChgCodes.includes(chargeCodeItem.id)) {
                    this.selectedEsiid = null;
                    this.isESIIDDisabled = true;
                }
                else {
                    this.isESIIDDisabled = false;
                }

                // Clear notes
                //this.notes = null;
            }

            return true;
        },
        submitPostAdjustment: async function () {

            this.$store.dispatch('shell/turnOnSpinner', true);

            const excludeEsiForChgCodes = ['AMA_TX_DAMAGECLAIM'];
            if (excludeEsiForChgCodes.includes(this.selectedChargeCode)) {
                this.selectedEsiid = null;
            }

            console.log('submitPostAdjustment: selectedChargeCode: ' + this.selectedChargeCode + ', selectedEsiid: ' + this.selectedEsiid);

            let request = {
                BluenetAuthToken: this.$route.query.token,
                BluenetWebToken: this.$route.query.webToken,
                //BluenetAuthToken: this.$route.params.authToken,
                //BluenetWebToken: this.$route.params.webToken,
                SelectedAdjChargeCode: this.selectedChargeCode,
                BillDescription: this.billDescription,
                SelectedESIID: this.selectedEsiid,
                Amount: this.amount,
                Notes: this.notes,
            };

            let response = await Repo.PostAdjustmentService.SubmitPostAdjustment(request);

            if (response.isSuccess) {
                this.onCancel(); // Reset form fields for potential new post adjustment
                this.systemMessage = response.systemMessage;
                this.systemMessageStyleClass = "alert-success";
                console.log('Successfully posted adjustment');
                console.log(response);
            }
            else {
                this.systemMessage = response.systemMessage;
                this.systemMessageStyleClass = "alert-danger";
            }

            this.$store.dispatch('shell/turnOffSpinner', false);
        },
        getPostAdjustmentViewModel: async function () {

            // Disable form during load
            this.isFormDisabled = true;

            let request = {
                BluenetAuthToken: this.$route.query.token,
                BluenetWebToken: this.$route.query.webToken
                //BluenetAuthToken: this.$route.params.authToken,
                //BluenetWebToken: this.$route.params.webToken
            };

            let response = await Repo.PostAdjustmentService.GetPostAdjustmentViewModel(request);

            // Check if view model retrieved successfully
            if (!response) {
                this.systemMessage = "Error encountered when calling the post adjustment data service.  Please try again or contact the System Administrator if problem persists";
                this.systemMessageStyleClass = "alert-danger";
                return; // Stop form loading 
            }

            // Check if view model retrieved successfully
            if (!response.isSuccess) {
                this.systemMessage = response.systemMessage;
                this.systemMessageStyleClass = "alert-danger";
                return; // Stop form loading 
            }

            // Check if user has permissions to create a post adjustment
            if (!response.securityPermission.isPostAdjustmentAllowed) {
                this.systemMessage = response.securityPermission.systemMessage;
                this.systemMessageStyleClass = "alert-danger";
                return; // Stop form loading 
            }

            // Load adjustment types
            response.chargeAdjustCodes.forEach((item, index) => {
                this.chargeCodeList.push(
                    {
                        id: item.chargeAdjustCd,
                        desc: item.ambitDescAmt,
                        amount: item.amount,
                        origDesc: item.description
                    }
                );
            });

            // Load Esiids for customer
            if (response.esiidServiceLocationIds.length > 1) {
                this.esiidList.push(
                    {
                        id: -1,
                        desc: "<All>",
                    });
            }
            //else {
            //    this.esiidList.push(
            //        {
            //            id: null,
            //            desc: "Select ESIID",
            //        });
            //}

            response.esiidServiceLocationIds.forEach((item, index) => {
                this.esiidList.push(
                    {
                        id: item.serviceLocationId,
                        desc: item.esiid,
                    }
                );
            });

            // Enable form 
            this.isFormDisabled = false;

            //console.log(this.chargeCodeList);

        },
        formatAmount: function (inputText) {
            if (this.isNumeric(inputText)) {
                return parseFloat(inputText).toFixed(2);
            }
            else {
                return inputText;
            }
        },
        isNumeric: function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
    }
};
</script>
